/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../body-row.component.ngfactory';
import * as i2 from '@swimlane/ngx-datatable/release/components/body/body-row.component';
import * as i3 from '@swimlane/ngx-datatable/release/services/scrollbar-helper.service';
import * as i4 from '@angular/common';
import * as i5 from '@swimlane/ngx-datatable/release/components/body/summary/summary-row.component';
const styles_DataTableSummaryRowComponent:any[] = ([] as any[]);
export const RenderType_DataTableSummaryRowComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DataTableSummaryRowComponent,data:{}});
function View_DataTableSummaryRowComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'datatable-body-row',
      [['tabindex','-1']],[[8,'className',0],[4,'height','px'],[4,'width','px']],[[(null as any),
          'keydown'],[(null as any),'mouseenter']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onKeyDown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseenter' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onMouseenter($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i1.View_DataTableBodyRowComponent_0,i1.RenderType_DataTableBodyRowComponent)),
      i0.ɵdid(311296,(null as any),0,i2.DataTableBodyRowComponent,[i0.KeyValueDiffers,
          [1,i3.ScrollbarHelper],i0.ChangeDetectorRef,i0.ElementRef],{columns:[0,'columns'],
          innerWidth:[1,'innerWidth'],row:[2,'row'],rowIndex:[3,'rowIndex'],offsetX:[4,
              'offsetX'],rowHeight:[5,'rowHeight']},(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n  ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = _co._internalColumns;
    const currVal_4:any = _co.innerWidth;
    const currVal_5:any = _co.summaryRow;
    const currVal_6:any = (0 - 1);
    const currVal_7:any = _co.offsetX;
    const currVal_8:any = _co.rowHeight;
    _ck(_v,1,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).cssClass;
    const currVal_1:any = i0.ɵnov(_v,1).rowHeight;
    const currVal_2:any = i0.ɵnov(_v,1).columnsTotalWidths;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export function View_DataTableSummaryRowComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n  '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_DataTableSummaryRowComponent_1)),
      i0.ɵdid(16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i5.DataTableSummaryRowComponent = _v.component;
    const currVal_0:any = (_co.summaryRow && _co._internalColumns);
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
export function View_DataTableSummaryRowComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'datatable-summary-row',
      [['class','datatable-summary-row']],(null as any),(null as any),(null as any),
      View_DataTableSummaryRowComponent_0,RenderType_DataTableSummaryRowComponent)),
      i0.ɵdid(573440,(null as any),0,i5.DataTableSummaryRowComponent,([] as any[]),
          (null as any),(null as any))],(null as any),(null as any));
}
export const DataTableSummaryRowComponentNgFactory:i0.ComponentFactory<i5.DataTableSummaryRowComponent> = i0.ɵccf('datatable-summary-row',
    i5.DataTableSummaryRowComponent,View_DataTableSummaryRowComponent_Host_0,{rows:'rows',
        columns:'columns',rowHeight:'rowHeight',offsetX:'offsetX',innerWidth:'innerWidth'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3N1bW1hcnkvc3VtbWFyeS1yb3cuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9zdW1tYXJ5L3N1bW1hcnktcm93LmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3N1bW1hcnkvc3VtbWFyeS1yb3cuY29tcG9uZW50LmQudHMuRGF0YVRhYmxlU3VtbWFyeVJvd0NvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3N1bW1hcnkvc3VtbWFyeS1yb3cuY29tcG9uZW50LmQudHMuRGF0YVRhYmxlU3VtbWFyeVJvd0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICA8ZGF0YXRhYmxlLWJvZHktcm93XG4gICAgKm5nSWY9XCJzdW1tYXJ5Um93ICYmIF9pbnRlcm5hbENvbHVtbnNcIlxuICAgIHRhYmluZGV4PVwiLTFcIlxuICAgIFtpbm5lcldpZHRoXT1cImlubmVyV2lkdGhcIlxuICAgIFtvZmZzZXRYXT1cIm9mZnNldFhcIlxuICAgIFtjb2x1bW5zXT1cIl9pbnRlcm5hbENvbHVtbnNcIlxuICAgIFtyb3dIZWlnaHRdPVwicm93SGVpZ2h0XCJcbiAgICBbcm93XT1cInN1bW1hcnlSb3dcIlxuICAgIFtyb3dJbmRleF09XCItMVwiPlxuICA8L2RhdGF0YWJsZS1ib2R5LXJvdz5cbiAgIiwiPGRhdGF0YWJsZS1zdW1tYXJ5LXJvdz48L2RhdGF0YWJsZS1zdW1tYXJ5LXJvdz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQ0U7TUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQTthQUFBO1VBQUE7VUFBQTtjQUFBLHFEQVFrQjtVQUFBOztJQUhoQjtJQUZBO0lBSUE7SUFDQTtJQUpBO0lBRUE7SUFORixXQUtFLFVBRkEsVUFJQSxVQUNBLFVBSkEsVUFFQSxTQU5GOztJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEsNkJBQUE7Ozs7b0JBREYseUNBQ0U7TUFBQTthQUFBO1VBQUEsd0JBU3FCOztJQVJuQjtJQURGLFdBQ0UsU0FERjs7OztvQkNERjtNQUFBO2lGQUFBO2FBQUE7VUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// ./compiled/node_modules/@swimlane/ngx-datatable/release/components/body/summary/summary-row.component.ngfactory.ts